function TransactionHistoryChart({ data }) {
  const rawMax = Math.max(...data.map((d) => d.value), 0);

  const getCeiling = (val) => {
    if (val === 0) return 100;
    const magnitude = Math.pow(10, Math.floor(Math.log10(val)));
    const step = magnitude / 2;
    return Math.ceil((val * 1.1) / step) * step;
  };

  const chartCeiling = getCeiling(rawMax);
  const steps = 4;
  const yAxisPoints = Array.from({ length: steps + 1 }, (_, i) =>
    Math.round((chartCeiling / steps) * (steps - i)),
  );

  return (
    <div className="ledge-container">
      <div className="ledge-main-layout">
        <div className="ledge-y-axis-labels">
          {yAxisPoints.map((val, i) => (
            <div key={i} className="y-label">
              ${val.toLocaleString()}
            </div>
          ))}
        </div>

        <div className="ledge-chart-area">
          <div className="ledge-grid-lines">
            {yAxisPoints.map((_, i) => (
              <div key={i} className="grid-line" />
            ))}
          </div>

          <div className="ledge-bars-wrapper">
            {data.map((item, index) => {
              const barHeightPercent = (item.value / chartCeiling) * 100;

              return (
                <div key={index} className="ledge-bar-group">
                  {/* The value now uses the same height % to stay pinned to the bar top */}
                  <span
                    className="ledge-bar-value"
                    style={{ bottom: `calc(${barHeightPercent}% + 8px)` }}
                  >
                    {item.value}
                  </span>

                  <div
                    className="ledge-bar-fill"
                    style={{ height: `${barHeightPercent}%` }}
                  />

                  <span className="ledge-bar-label">{item.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionHistoryChart;
